import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from "@angular/core";
import L from 'leaflet';
import {RouteService} from "../../../services/routeService";
import {NotificationService} from "../../../services/notificationService";
import {GeneralService} from "../../../services/generalService";
import {DICTIONARY} from "../../../dictionary";
import _ from "lodash";

@Component({
	selector: 'account-user-info',
	templateUrl: './account-user-info.component.html',
})
export class AccountUserInfoComponent implements OnInit {
	@Input() showAccountInfoPopup: boolean;
	@Input() mailboxEmail: string;

	@Output() close = new EventEmitter<void>();

	accountInfoPopupTabs = {
		userDevices: 'User Devices',
		userSignIns: 'Mailbox Login Activity',
	};
	dic = DICTIONARY;
	activeTab = this.accountInfoPopupTabs.userDevices;
	isLoaded = false;
	accountInfo;

	constructor(public gs: GeneralService,
				private rs: RouteService,
				private ns: NotificationService) {}

	ngOnInit() {
		this.activeTab = this.accountInfoPopupTabs.userDevices;
		this.getAccountCompromisedUser();
	}

	onClose() {
		this.close.emit();
	}

	getAccountCompromisedUser = () => {
		this.rs.getAccountCompromisedUsers(this.mailboxEmail).then(response => {
			const userAccountCompObj = response?.misc.account_compromised;
			this.accountInfo = {
				devices: userAccountCompObj.devices || [],
				email: this.mailboxEmail
			};

			this.accountInfo.devices = _.map(this.accountInfo.devices, device => {
				device.agent = device.agent || {};
				if (device.agent.raw) {
					device.agent.raw = JSON.parse(device.agent.raw);
				}
				return device;
			});

			this.prepareDevicesLocationInfo(this.accountInfo.devices);
			this.isLoaded = true;
		}, (err) => {
			this.isLoaded = true;
		});
	}

	prepareDevicesLocationInfo(deviceList) {
		this.accountInfo.locations = [];
		let bounds = [];
		deviceList?.forEach((deviceObj) => {
			deviceObj.location.sort((a, b) => new Date(b.last_used || b.created).getTime() - new Date(a.last_used || a.created).getTime());
			deviceObj.location.forEach((locationObj) => {
				if (locationObj.ll.length === 2) {
					const marker = {
						icon: this.gs.leafletDefaultIcon,
						lat: locationObj.ll[0],
						lng: locationObj.ll[1],
						title: this.parseDeviceClient(deviceObj),
						draggable: false
					};

					bounds.push([locationObj.ll[0],locationObj.ll[1]]);

					this.accountInfo.locations.push(marker);
				}
			})
		});

		if (bounds?.length) {
			const centroid = new L.LatLngBounds(bounds).getCenter();
			this.accountInfo.center_location = {
				lat: centroid?.lat,
				lng: centroid?.lng,
				zoom: 2
			};
		}
		else {
			this.accountInfo.center_location = {
				lat: 0,
				lng: 0,
				zoom: 2
			};
		}
	}

	parseDeviceClient(device) {
		if (device.agent.browser) {
			return `${device.agent.browser.name} (${device.agent.browser.version}), ${device.agent.os.name} (${device.agent.os.version})`;
		}
		if (device.agent.raw) {
			return `${device.agent.raw.ua || 'N/A'}`;
		}

		return 'N/A';
	}

	selectAccountInfoPopupTab = (tab) => {
		this.activeTab = tab;

		if (tab === this.accountInfoPopupTabs.userSignIns) {
			if (this.accountInfo.userSignObj?.data) {
				return;
			}
			this.accountInfo.userSignObj = {inProcess: true};
			this.rs.getUserSignIns(this.mailboxEmail).then(response => {
				this.accountInfo.userSignObj.data = response || [];
				this.accountInfo.userSignObj.data?.forEach((signInObj) => {
					signInObj.auth = this.detectAuthMethod(signInObj);
				});
				this.accountInfo.userSignObj.inProcess = false;
			}, () => {
				this.ns.showErrorMessage('Insufficient permissions to perform this action. To support this action, click on the "Grant Advanced Permissions" button from the Exchange Server integration window.');
				this.accountInfo.userSignObj.inProcess = false;
			});
		}
	}

	detectAuthMethod(signIn) {
		if (!signIn || !signIn.status) {
			return "Unknown";
		}

		const details = (signIn.status.additionalDetails || "").toLowerCase();
		const client = (signIn.clientAppUsed || "").toLowerCase();
		const interactive = !!signIn.isInteractive;

		if (!interactive || details.includes("claim in the token")) {
			return "Token refresh (no password, MFA claim reused)";
		}

		if (details.includes("mfa requirement satisfied by multi-factor device")) {
			return "Password + MFA auto-approved (trusted device)";
		}

		if (details.includes("mfa completed")) {
			return "Password + MFA (Authenticator or device-based)";
		}

		if (details.includes("satisfied") && details.includes("mfa")) {
			return "Password + MFA satisfied (non-interactive)";
		}

		if (details.includes("password")) {
			return "Password-only";
		}

		if (details.includes("fido") ||
			details.includes("hello") ||
			details.includes("biometric") ||
			details.includes("webauthn"))
		{
			return "Passkey / FIDO2 authentication";
		}

		if (client.includes("browser")) {
			return "Browser login (likely password + MFA)";
		}

		if (client.includes("mobile") || client.includes("desktop")) {
			return "Mobile/Desktop app login (likely password + MFA or token refresh)";
		}

		return "Unknown";
	}

	showDeviceAction = (deviceObj) => {
		return ['Delete'];
	}

	selectDeviceAction = (deviceObj, action) => {
		switch (action) {
			case 'Delete':
				this.rs.deleteUserDevice(this.accountInfo.email, deviceObj._id).then(() => {
					this.accountInfo.devices = this.accountInfo.devices.filter(itm => itm._id.toString() !== deviceObj._id.toString());
					this.prepareDevicesLocationInfo(this.accountInfo.devices);
					this.ns.showInfoMessage(this.dic.MESSAGES.operationCalled);
				}, () => {
				});
				break;
		}
	}

	openLocation(ll) {
		this.gs.openLocation(ll);
	}
}

